import { render } from "./DevolucaoVendaPagamento.vue?vue&type=template&id=137c6d00&ts=true"
import script from "./DevolucaoVendaPagamento.vue?vue&type=script&lang=ts"
export * from "./DevolucaoVendaPagamento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__